import {loginAccount, getCodeImg, getUserInfo} from "@/api";
import {ElMessage} from 'element-plus'
import loginImg from '@/assets/images/login_ch.png'

export default {
    data() {
        return {
            year: "2024",
            loginForm: {
                username: "",
                password: "",
                rememberMe: false,
                code: "",
                uuid: ""
            },
            logining: false,
            // 验证码开关
            captchaOnOff: true,
            codeUrl: '',
            token: null,
            loginImg: loginImg
        }
    },
    created() {
        this.year = new Date().getFullYear();
        window.sessionStorage.clear();
        window.localStorage.clear();
        this.getCode();
    },
    methods: {
        toURL: function () {
            this.$router.push({path: '/admin/home'});
        },
        // 获取图形验证码
        getCode() {
            getCodeImg().then(res => {
                // console.log(res)
                this.captchaEnabled = res.captchaEnabled === undefined ? true : res.captchaEnabled
                if (this.captchaEnabled) {
                    this.codeUrl = 'data:image/gif;base64,' + res.data.img
                    this.loginForm.uuid = res.data.uuid
                }
            })
        },
        handleLogin: function () {
            const username = this.loginForm.username;
            const password = this.loginForm.password;
            const code = this.loginForm.code;
            if (username === "" || username === null || username === undefined) {
                ElMessage.error({
                    message: '用户名不能为空哦',
                    type: 'error'
                });
            } else if (password === "" || password === null || password === undefined) {
                ElMessage.error({
                    message: '用户密码不能为空哦',
                    type: 'error'
                });
            } else if (code === "" || code === null || code === undefined) {
                ElMessage.error({
                    message: '验证码不能为空哦',
                    type: 'error'
                });
            } else {
                this.logining = true;
                const data = {
                    username: this.loginForm.username,
                    password: this.loginForm.password,
                    code: this.loginForm.code,
                    uuid: this.loginForm.uuid
                }
                loginAccount(data).then(res => {
                    // console.log(res)
                    this.logining = false;
                    if (res.code === 200) {
                        window.localStorage.clear();
                        window.sessionStorage.clear();
                        window.sessionStorage.setItem("xtoken", res.token);
                        this.getUserDetailInfo(); // 获取用户详细信息
                        setTimeout(()=>{
                            this.$router.push({path: '/admin/home'});
                        },1000)
                    } else if (res.code === 500) {
                        ElMessage.error({
                            message: res.msg,
                            type: 'error'
                        });
                    }
                }).catch(error => {
                    this.logining = false;
                    ElMessage.error({
                        message: error,
                        type: 'error'
                    });
                    if (this.captchaOnOff) {
                        this.getCode();
                    }
                });

            }
        },

        // 获取用户详细信息
        getUserDetailInfo() {
            getUserInfo().then(res => {
                console.log(res);
                if (res.data.code === 200) {
                    window.sessionStorage.setItem("user", JSON.stringify(res.data.user));
                    window.sessionStorage.setItem("roles", JSON.stringify(res.data.roles));
                    window.sessionStorage.setItem("permissions", JSON.stringify(res.data.permissions));
                }
            })
        },
    }
}
